import { Field, useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import { CanGoNext } from "../../models/CanGoNext";
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { SettingTextField } from '../settingFields/SettingTextField';
import { requiredValidation } from '../../utilities/Validation';
import SettingSelectField from '../settingFields/SettingSelectField';

export interface DetailFields {
    displayName: string;
    description: string;
    copyOf: string;
    singleOwner: boolean;
    autoIdNumber: boolean;
}

interface CustomFieldFormProps extends CanGoNext {
    options?: any;
    setSideBarStepDescription?: (newDescription) => void;
    masterGroupTypeOptions?: any
}

const CustomFieldForm: FC<CustomFieldFormProps> = ({ masterGroupTypeOptions, onNext, options = [], setSideBarStepDescription = () => { } }) => {
    const { translate } = useLocale();
    const [uiTypeSelected, setUiTypeSelected] = useState(false);
    const { errors, values } = useFormikContext<any>();
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (Object.keys(errors as any).length > 0) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
    }, [errors])

    useEffect (() => {
        setUiTypeSelected(true);
    }, [values.uiType])

    return <div className="pt-3 pr-3 h-full relative">
        <div className="flex flex-col ">
            <SettingTextField
                accessor={'name'}
                required validation={(value) => requiredValidation(value, translate)}
                isCard
                autoFocus={true}
                displayName={translate.byKey(TranslationKeys.fieldName)}></SettingTextField>
            <SettingTextField
                accessor={'tooltip'}
                isCard
                displayName={translate.byKey(TranslationKeys.toolTip)}></SettingTextField>
            <SettingSelectField
                key={"uiType"}
                accessor={"uiType"}
                displayName={translate.byKey(TranslationKeys.fieldType)}
                options={options}
                required
                className="">
            </SettingSelectField>

            <div className="flex flex-row mb-1 mt-2">
                <label>
                    <Field className="mr-1" type="checkbox" name="enabled" />
                    {translate.byKey(TranslationKeys.enabled)}
                </label>
            </div>
            <div className="flex flex-row mb-1 mt-2">
                <label>
                    <Field className="mr-1" type="checkbox" name="required" />
                    {translate.byKey(TranslationKeys.required)}
                </label>
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 w-full">
            <button
                className={`secondary py-1 px-5 ${(values.uiType || values.name) && !hasError ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                type="button"
                onClick={(uiTypeSelected) && onNext ? (e) => { if ((values.uiType || values.name) && !hasError) { onNext(e); setSideBarStepDescription((values as any)['name']); } } : () => { }}>{translate.byKey(TranslationKeys.next)}</button>
        </div>
    </div >;
}

export default CustomFieldForm;
